import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

function StaticWebsiteDesigning() {
  return (
    <>
      <Helmet>
        <title>Static Website Designing Company Dubai, abu dhabi, ajman, Sharjah, UAE</title>
        <meta name="description" content={"Looking for a reliable static website designing company in Dubai? Specialising in static website designing in Dubai, we build fast, responsive, and SEO-friendly business websites. Request a free quote now. "} />
        <meta name="keywords" content={"Website SEO  "} />
        <link rel="canonical" href={"https://www.websiteseo.ae/Static-website-designing"} />
        <script type="application/ld+json">
          {JSON.stringify({
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Websiteseo",
  "url": "https://www.websiteseo.ae/",
  "logo": {
    "@type": "ImageObject",
    "url": "https://www.websiteseo.ae/images/img/logo.png"
  },
  "description": "WebsiteSEO is a digital solutions agency offering website design and development, SEO, mobile app development, domain registration, web hosting, social media marketing, email marketing, SMS marketing, branding, and online marketing services to help businesses build and strengthen their digital presence.",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Office# 114 Al Ahbabi Building Damascus Street, Al Qusais Dubai, United Arab Emirates",
    "addressLocality": "Dubai",
    "addressRegion": "Dubai",
    "postalCode": "00000",
    "addressCountry": "UAE"
  },
  "contactPoint": [
    {
      "@type": "ContactPoint",
      "telephone": "+971 55 570 9788",
      "contactType": "customer service",
      "email": "sales@websiteseo.ae"
    }
  ]
})}
        </script>
      </Helmet>

<div>
  {/* HEADER
  ============================================= */}
  {/* END HEADER */}
  {/* HERO
  ============================================= */}
  <div className="inner-page-banner-wrap" style={{backgroundImage: 'url(/legacy/images/img/inner-banner-bg.jpg)', backgroundSize: 'cover', backgroundAttachment: 'fixed'}}>
    <div className="container">
      <h3>Static Website Designing</h3>
      <ul>
        <li><Link to="/">Home</Link></li>
        <li>Static Website Designing</li>
      </ul>
    </div>
  </div>
  <section className="gr--ghost ct-01 inner-page-hero content-section division">
    <div className="container">
      {/* CONTENT WRAPPER */}
      <div className="row d-flex align-items-center">
        {/* TEXT BLOCK */}
        <div className="col-lg-6">
          <div className="txt-block left-column wow animate__ animate__fadeInRight animated" style={{visibility: 'visible', animationName: 'fadeInRight'}}>
            {/* Module Subtitle */}
            <span className="module-subtitle">Static Website Designing</span>
            {/* Title */}
            <h1 className="fs-28 mb-2">Static Website Designing Company Dubai, abu dhabi, ajman, Sharjah, UAE</h1>
            {/* Text */}
            <p>In the midst of ever-evolving dynamics of online marketing, Websiteseo.ae takes a pioneering approach with a revolutionary web design method that belies the notion that complexity equals effectiveness. Static websites have been shown to be an effective, low-maintenance solution for businesses wishing to have a solid web presence without the cost of complex technologies.</p>
          </div>
        </div>	{/* END TEXT BLOCK */}
        {/* IMAGE BLOCK */}
        <div className="col-lg-6">
          <div className="psn-rlv">
            <div className="img-block right-column wow animate__ animate__fadeInLeft animated lft-p" style={{visibility: 'visible', animationName: 'fadeInLeft'}}>
              <img className="img-fluid lt-img  bdr-r" src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/5bffa255-785a-443d-c5e4-02f81f876400/w=1920,sharpen=1" alt="content-image" />
              <img className="img-fluid  psn-sm-imgs up-down" src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/3e2b5d72-322d-4194-7a42-6546aedc2500/w=1920,sharpen=1" alt="content-image" />
            </div>
          </div>
        </div>
      </div>   {/* END CONTENT WRAPPER */}
    </div>	   {/* End container */}
  </section>
  <div className="pt-100 ct-01 content-section division" style={{backgroundColor: '#f8f8f8'}}>
    <div className="container">
      {/* CONTENT WRAPPER */}
      <div className="row d-flex align-items-center">
        {/* IMAGE BLOCK */}
        <div className="col-lg-6 order-last order-lg-2">
          <div className="psn-rlv">
            <div className="img-block right-column wow animate__ animate__fadeInLeft animated lft-p" style={{visibility: 'visible', animationName: 'fadeInLeft', margin: 0}}>
              <img className="img-fluid lt-img  bdr-r" style={{padding: 0}} src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/56edf470-a8eb-4290-13f3-f5a030ff4b00/w=1920,sharpen=1" alt="content-image" />
            </div>
          </div>
        </div>
        {/* TEXT BLOCK */}
        <div className="col-lg-6 order-first order-lg-2">
          <div className="txt-block right-column wow animate__ animate__fadeInLeft animated" style={{visibility: 'visible', animationName: 'fadeInLeft'}}>
            {/* Title */}
            <h4 className="fs-25">Accessible Web Presence</h4>
            <p>Our journey starts with the appreciation of the specific needs of businesses within the UAE's fast-paced market. Not all businesses need a highly advanced, database-powered website. For some, a simple, elegant, and straightaway accessible web presence is the route to online success. Static websites provide exactly this – a harmonious blend of simplicity and punch.</p>
            <p>
              The elegance of static websites is in their very method of web design. With minimal HTML coding and simple scripting, these sites pierce the digital clutter, giving businesses a solid platform that:
            </p>
            {/* Text */}
            {/* CONTENT BOX #1 */}
            <div className="cbox-8 ico-15">
              <div className="ico-wrap color--purple">
                <div className="cbox-8-ico"><span className="flaticon-check" /></div>
              </div>
              <div className="cbox-8-txt">
                <p>Is ideal for small to medium-sized businesses</p>
              </div>
            </div>
            {/* CONTENT BOX #1 */}
            <div className="cbox-8 ico-15">
              <div className="ico-wrap color--purple">
                <div className="cbox-8-ico"><span className="flaticon-check" /></div>
              </div>
              <div className="cbox-8-txt">
                <p>Is suitable for startup businesses</p>
              </div>
            </div>
            {/* CONTENT BOX #1 */}
            <div className="cbox-8 ico-15">
              <div className="ico-wrap color--purple">
                <div className="cbox-8-ico"><span className="flaticon-check" /></div>
              </div>
              <div className="cbox-8-txt">
                <p> Gives professional portfolios a sleek online base</p>
              </div>
            </div>
            {/* CONTENT BOX #1 */}
            <div className="cbox-8 ico-15">
              <div className="ico-wrap color--purple">
                <div className="cbox-8-ico"><span className="flaticon-check" /></div>
              </div>
              <div className="cbox-8-txt">
                <p>Offers clean informational websites</p>
              </div>
            </div>
            <div className="cbox-8 ico-15">
              <div className="ico-wrap color--purple">
                <div className="cbox-8-ico"><span className="flaticon-check" /></div>
              </div>
              <div className="cbox-8-txt">
                <p>Produces strong landing pages</p>
              </div>
            </div>
          </div>
        </div>	{/* END TEXT BLOCK */}
      </div>   {/* END CONTENT WRAPPER */}
    </div>	 {/* End container */}
  </div>
  <div className="pt-100 ct-01 content-section division pb-100 " style={{backgroundColor: '#f8f8f8'}}>
    <div className="container">
      {/* CONTENT WRAPPER */}
      <div className="row d-flex align-items-center">
        {/* TEXT BLOCK */}
        <div className="col-lg-6 order-first order-lg-2">
          <div className="txt-block right-column wow animate__ animate__fadeInLeft animated pdg-l-0" style={{visibility: 'visible', animationName: 'fadeInLeft'}}>
            {/* Title */}
            <h4 className="fs-25">What Makes Us Excel?</h4>
            <p>Performance is where static websites really excel. Our development process is carefully designed to produce websites that are:</p>
            {/* Text */}
            <div className="cbox-8 ico-15">
              <div className="ico-wrap color--purple">
                <div className="cbox-8-ico"><span className="flaticon-check" /></div>
              </div>
              <div className="cbox-8-txt">
                <p>Light and extremely fast-loading</p>
              </div>
            </div>
            <div className="cbox-8 ico-15">
              <div className="ico-wrap color--purple">
                <div className="cbox-8-ico"><span className="flaticon-check" /></div>
              </div>
              <div className="cbox-8-txt">
                <p>Cross-browser compatible</p>
              </div>
            </div>
            <div className="cbox-8 ico-15">
              <div className="ico-wrap color--purple">
                <div className="cbox-8-ico"><span className="flaticon-check" /></div>
              </div>
              <div className="cbox-8-txt">
                <p>Smoothly responsive on mobile</p>
              </div>
            </div>
            <div className="cbox-8 ico-15">
              <div className="ico-wrap color--purple">
                <div className="cbox-8-ico"><span className="flaticon-check" /></div>
              </div>
              <div className="cbox-8-txt">
                <p>Written with clean, efficient code</p>
              </div>
            </div>
            <div className="cbox-8 ico-15">
              <div className="ico-wrap color--purple">
                <div className="cbox-8-ico"><span className="flaticon-check" /></div>
              </div>
              <div className="cbox-8-txt">
                <p>Search engine optimized</p>
              </div>
            </div>
            <p>
              The technical foundation of our static website design relies on the latest frameworks and technologies. We design interactive and beautiful websites using HTML5, CSS3, and vanilla JavaScript. We are comfortable with dealing with high-level static site generators such as Jekyll, Hugo, and Gatsby and provide deployment platforms such as Netlify and Vercel.
            </p>
          </div>
        </div>	{/* END TEXT BLOCK */}
        {/* IMAGE BLOCK */}
        <div className="col-lg-6 order-last order-lg-2">
          <div className="psn-rlv">
            <div className="img-block right-column wow animate__ animate__fadeInLeft animated lft-p" style={{visibility: 'visible', animationName: 'fadeInLeft', margin: 0}}>
              <img className="img-fluid lt-img  bdr-r" style={{padding: 0}} src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/ff941ea3-a857-4eee-82c3-047062196800/w=1920,sharpen=1" alt="content-image" />
            </div>
          </div>
        </div>
      </div>   {/* END CONTENT WRAPPER */}
    </div>	 {/* End container */}
  </div>
  <div className="bg--07 bg--scroll py-100 ct-01 content-section division grdnt-bg">
    <div className="container">
      {/* CONTENT WRAPPER */}
      <div className="row d-flex align-items-center">
        {/* IMAGE BLOCK */}
        <div className="col-lg-6 order-last order-lg-2">
          <div className="img-block left-column wow animate__ animate__fadeInRight animated " style={{visibility: 'visible', animationName: 'fadeInRight'}}>
            <div className="up-down">
              <img className="img-fluid " src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/9fff9c37-5112-4ed1-c582-ae3739300b00/w=1920,sharpen=1" alt="content-image" />
            </div>
          </div>
        </div>
        {/* TEXT BLOCK */}
        <div className="col-lg-6 order-first order-lg-2">
          <div className="txt-block color--white right-column wow animate__ animate__fadeInLeft animated" style={{visibility: 'visible', animationName: 'fadeInLeft'}}>
            {/* Title */}
            <h2 className="fs-46">Security and Stability at an Affordable Price</h2>
            <p>Security and stability are of paramount importance in our solution. Unlike with dynamic complex sites, static websites provide a relatively more secure framework with fewer flaws. We have witnessed thousands of companies take advantage of this model – from established UAE companies looking for a rock-solid but non-complex presence online to startup companies in Dubai.</p>
            <p>
              Affordability is another significant advantage.  For companies that want to create a professional online presence without incurring a huge expense, static websites provide the perfect solution.
            </p>
            <p>
              Our dedication extends beyond the development of a website. We're constructing a digital property that embodies your brand, conveys your value proposition, and creates new avenues of customer interaction. Whether you're a Dubai-based local business or an enterprise with regional aspirations, our static website design services are designed to highlight your distinct strengths.
            </p>
          </div>
        </div>	{/* END TEXT BLOCK */}
      </div>   {/* END CONTENT WRAPPER */}
    </div>	 {/* End container */}
  </div>
  <div className="pt-100 ct-01 content-section division pb-100">
    <div className="container">
      {/* CONTENT WRAPPER */}
      <div className="row d-flex align-items-center">
        {/* TEXT BLOCK */}
        <div className="col-lg-6 order-first order-lg-2">
          <div className="txt-block right-column wow animate__ animate__fadeInLeft animated pdg-l-0" style={{visibility: 'visible', animationName: 'fadeInLeft'}}>
            {/* Title */}
            <h4 className="fs-25">Who should Choose Us?</h4>
            <p>Best for businesses who appreciate:  direct and clean communication, Quick site loading, Lower cost of hosting and maintenance, Quick deployment and Straightforward business communication</p>
          </div>
        </div>	{/* END TEXT BLOCK */}
        {/* IMAGE BLOCK */}
        <div className="col-lg-6 order-last order-lg-2">
          <div className="psn-rlv">
            <div className="img-block right-column wow animate__ animate__fadeInLeft animated lft-p" style={{visibility: 'visible', animationName: 'fadeInLeft', margin: 0}}>
              <img className="img-fluid lt-img  bdr-r" style={{padding: 0}} src="https://imagedelivery.net/WefzwPpyYAgz4nGrybaw0Q/ce0abff0-ff3b-494b-c2ec-45fc57c0e600/w=1920,sharpen=1" alt="content-image" />
            </div>
          </div>
        </div>
      </div>   {/* END CONTENT WRAPPER */}
    </div>	 {/* End container */}
  </div>
  {/* FOOTER
  ============================================= */}
  {/* END FOOTER */}
</div>

    </>
  );
}

export default StaticWebsiteDesigning;
